<template>
  <base-wrapper>
    <div class="space-y-4">
      <div class="flex items-center justify-end gap-x-2">
        <base-button :to="{ name: 'topup.saldo-stockist.tambah' }"
          >Topup Saldo Stockist</base-button
        >
      </div>
      <div>
        <datatable
          :columns="columns"
          :data="balanceTrxes.data"
          :scroll-x="false"
          :total="balanceTrxes.meta.page.total"
          :perPage="balanceTrxes.meta.page.perPage"
          :currentPage="balanceTrxes.meta.page.currentPage"
          @pagechanged="onPageChanged"
        >
          <template v-slot:tbody="{ classes }">
            <tr
              v-for="(balanceTrx, index) in balanceTrxes.data"
              :key="balanceTrx.id"
              :class="[
                classes.tr,
                index % 2 === 0 ? 'bg-white' : 'bg-gray-50',
                'bg-white hover:bg-green-100',
              ]"
            >
              <td :class="[classes.td]">
                <span class="font-bold text-gray-900">{{
                  getSingleIncluded(
                    balanceTrxes,
                    balanceTrx.relationships.office.data.id
                  ).attributes.code
                }}</span>
              </td>
              <td :class="classes.td">
                {{ balanceTrx.attributes.createdAt | formatDate }}
              </td>
              <td :class="[classes.td, 'text-right']">
                {{ balanceTrx.attributes.order_balance_amount | toCurrency }}
              </td>
            </tr>
          </template>
        </datatable>
      </div>
    </div>
    <loading v-if="loading" />
  </base-wrapper>
</template>

<script>
import { requestMixin } from '@/mixins/request/request';
import { mapActions } from 'vuex';

export default {
  mixins: [requestMixin],
  data() {
    return {
      balanceTrxes: {
        data: [],
        meta: {
          page: {
            total: 0,
          },
        },
      },
      loading: false,
    };
  },
  computed: {
    columns() {
      return [
        { id: 'office_code', name: 'Kode Stockist' },
        { id: 'createdAt', name: 'Tanggal Top Up' },
        { id: 'amount', name: 'Nominal Topup', theadClass: 'text-right' },
      ];
    },
  },
  methods: {
    ...mapActions({
      createAlert: 'alert/createAlert',
    }),
    async loadBalanceTrxes(params = {}) {
      this.loading = true;

      const [res, error] = await this.request('/api/v1/balance-trxes', {
        params: {
          'page[size]': 5,
          'filter[trx_type]': 'topup_stockist',
          include: 'office',
          'fields[balance-trxes]': 'office,createdAt,order_balance_amount',
          'fields[offices]': 'code',
          'sort': '-id',
          ...params,
        },
      });

      if (!error) {
        this.balanceTrxes = res;
      }

      this.loading = false;
    },
    onPageChanged(page) {
      this.loadBalanceTrxes({
        'page[number]': page,
      });
    },
  },
  created() {
    this.loadBalanceTrxes();
  },
};
</script>
